import get from 'lodash/get';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';
import mergeWith from 'lodash/mergeWith';

export const envVarsCollector = {};

export const getEnvVars = (envVars) =>
  isObject(envVars) && Object.keys(envVars).length ? Object.freeze(envVars) : {};

export const parseEnvVars = (envKey) => {
  const env = get(window, envKey);

  const url = new URL(window.location.href);
  const debug = url.searchParams.get('debug');

  // display logs when debug is enabled even though they are disabled at properties.js
  if (env && debug === 'true') {
    const overridedProps = { ...env, REACT_APP_ENABLE_REDUX_LOGGER: true, REACT_APP_DEBUG: true };

    return getEnvVars(overridedProps);
  }

  try {
    return getEnvVars(JSON.parse(env));
  } catch {
    return getEnvVars(env);
  }
};

export const loadEnvVars = () =>
  mergeWith(
    envVarsCollector,
    process.env,
    parseEnvVars('env'),
    parseEnvVars('envProps'),
    (objValue, srcValue) => (isNil(srcValue) || srcValue === '' ? objValue : srcValue)
  );

export const getEnvVar = (envKeyVar) =>
  get(envVarsCollector, envKeyVar, get(loadEnvVars(), envKeyVar));
